import React from 'react';

import { Typography } from 'components/shared/Typography';

import styles from './TextBlock.module.scss';

const TextBlock = ({
  className,
  type,
  data,
}: {
  className: any;
  type: any;
  data: any;
}) => {
  const _getVariant = () => {
    switch (type) {
      case 'heading1':
      case 'heading2': {
        return type;
      }
      case 'heading3': {
        return 'subtitle';
      }
      case 'text': {
        return 'body1';
      }
    }
  };

  return (
    <div className={className}>
      <Typography className={styles.block} withHTML variant={_getVariant()}>
        {data.replace(/\n/g, '<br>')}
      </Typography>
    </div>
  );
};

export default React.memo(TextBlock) as any;
